/**
 * Playback speed = target sim steps per animation frame.
 * Sub-1× values step on a subset of frames via an accumulator in ExhibitApp.
 */

export const SPEED_OPTIONS = [0.25, 0.5, 0.75, 1, 2, 4, 8] as const;

export type SpeedOption = (typeof SPEED_OPTIONS)[number];

export const DEFAULT_SPEED: SpeedOption = 1;

/** Snap to nearest allowed speed (URL restore / odd inputs). */
export function normalizeSpeed(n: number): SpeedOption {
  if (!Number.isFinite(n) || n <= 0) return DEFAULT_SPEED;
  let best: SpeedOption = DEFAULT_SPEED;
  let bestDist = Infinity;
  for (const opt of SPEED_OPTIONS) {
    const d = Math.abs(opt - n);
    if (d < bestDist) {
      bestDist = d;
      best = opt;
    }
  }
  return best;
}

/** Label for the transport select (e.g. 0.25 → "0.25×"). */
export function formatSpeedLabel(n: number): string {
  const s = normalizeSpeed(n);
  if (Number.isInteger(s)) return `${s}×`;
  // trim trailing zeros: 0.25 stays 0.25, 0.50 → 0.5
  const body = String(s)
    .replace(/(\.\d*?)0+$/, "$1")
    .replace(/\.$/, "");
  return `${body}×`;
}
